/**
 * Text cleaning shared by the line sheet feedback (KP-4572), the same rules
 * plg-go-be applies: trimmed, control characters removed (newlines kept where
 * the field is multi-line), and cut at a number of characters counted the way
 * a person counts them (code points, not UTF-16 units).
 */

// eslint-disable-next-line no-control-regex
const CONTROLS = /[\u0000-\u001f\u007f]/g
// eslint-disable-next-line no-control-regex
const CONTROLS_BUT_NEWLINE = /[\u0000-\u0009\u000b-\u001f\u007f]/g

/** The first max code points of text. */
export const clipRunes = (text, max) => Array.from(String(text || '')).slice(0, max).join('')

/** The number of code points in text. */
export const runeCount = text => Array.from(String(text || '')).length

/** Single-line text: no control characters, trimmed, at most max code points. */
export function cleanLine(text, max) {
  return clipRunes(String(text || '').replace(CONTROLS, '').trim(), max)
}

/** Multi-line text: newlines kept, other control characters removed. */
export function cleanBlock(text, max) {
  return clipRunes(String(text || '').replace(/\r\n?/g, '\n').replace(CONTROLS_BUT_NEWLINE, '').trim(), max)
}

const isHighSurrogate = code => code >= 0xd800 && code <= 0xdbff

/** The length (UTF-16 units) of the start next shares with prev, never splitting a code point. */
function sharedHead(prev, next, bound) {
  let h = 0
  while (h < bound && prev[h] === next[h]) h += 1
  return h > 0 && isHighSurrogate(prev.charCodeAt(h - 1)) ? h - 1 : h
}

/**
 * next is prev after the buyer typed or pasted, with the cursor at the end of
 * what went in. When it runs past max code points only the new part is cut, to
 * the room left, so text already there is never lost. Returns the text to keep
 * and where the cursor goes.
 */
export function fitInsertion(prev, next, cursor, max) {
  if (runeCount(next) <= max) return { text: next, cursor }
  const after = next.slice(cursor)
  if (!prev.endsWith(after)) {
    const text = clipRunes(next, max)
    return { text, cursor: text.length }
  }
  const head = prev.slice(0, sharedHead(prev, next.slice(0, cursor), prev.length - after.length))
  const room = Math.max(0, max - runeCount(head) - runeCount(after))
  const inserted = clipRunes(next.slice(head.length, cursor), room)
  return { text: head + inserted + after, cursor: head.length + inserted.length }
}
